import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import i18n from 'i18next'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { MktButton, UseHeader, UserNameInput, UseSwitchTab, MergeModal, BindVerifyModal, AgreementCheck } from '@cps'
import { modalLayer, toast, useHistoryNew } from '@utils'
import { memberMobx } from '@mobxStore'
import mktController from 'controllers/mktController'
import MemberApi from '@api/member.api'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
}
interface IState {
  showUserPanel: boolean;
  showVerifyPanel: boolean;
  userNameInfo: any;
  verifyCodeInfo: any;
}

const verifyCodeBind = memberMobx.verifyCodeTypes.binding
const verifyCodeMerge = memberMobx.verifyCodeTypes.merge
const verifyCodeRegister = memberMobx.verifyCodeTypes.register

const Binding: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { bindType } = match.params as any
  const { memberInfo } = memberMobx
  const { mobile, email, countryCode } = memberInfo
  const initialState: IState = {
    showUserPanel: true,
    showVerifyPanel: false,
    userNameInfo: {},
    verifyCodeInfo: {}
  }
  const [types, setTypes] = useState<any[]>([])
  const [type, setType] = useState<string>()
  const [userNameInfo, setUserNameInfo] = useState(initialState.userNameInfo)
  const [checked, setChecked] = useState<boolean>(false) // 是否勾选隐私协议
  const handleNext = () => {
    if (agreementJudge && !hasAgree && !checked) {
      toast({ message: i18n.t('mkt.common.tipPrivacy') })
      return
    }
    if (!userNameInfo.inputValue) {
      toast({ message: i18n.t(type === 'email' ? 'mkt.common.tipEmail' : 'mkt.common.tipMobile') })
      return
    } else if (!userNameInfo.valid) {
      toast({ message: i18n.t(type === 'email' ? 'mkt.common.tipEmailError' : 'mkt.common.tipMobileError') })
      return
    }
    if (type === 'mobile' && userNameInfo.inputValue === mobile && userNameInfo.countryCode === countryCode) {
      toast({ message: i18n.t('mkt.common.tipMobileNew') })
      return
    } else if (type === 'email' && userNameInfo.inputValue === email) {
      toast({ message: i18n.t('mkt.common.tipEmailNew') })
      return
    }
    const params: any = {}
    if (type === 'mobile') {
      params.mobile = userNameInfo.inputValue
      params.countryCode = userNameInfo.countryCode
    } else if (type === 'email') {
      params.email = userNameInfo.inputValue
    }
    memberMobx.checkAccount(params).then((res: any) => {
      if (res) {
        const bindMobile = (codeType) => {
          modalLayer(BindVerifyModal, {
            type: type,
            codeType,
            account: userNameInfo.inputValue,
            countryCode: `${userNameInfo.countryCode || 0}`
          }).then(() => {
            if (agreementJudge && !hasAgree && memberInfo?.memberId) {
              MemberApi.agreeClause({ memberId: memberInfo?.memberId }).then(() => {
                memberMobx.refreshMemeberBenefits()
              })
            }
            mktController.loginEnd(history)
          })
        }
        if (res.isRegister) {
          modalLayer(MergeModal, {
            info: {
              type,
              account: userNameInfo.inputValue,
              countryCode: userNameInfo.countryCode
            }
          }).then(() => {
            bindMobile(verifyCodeMerge)
          })
        } else {
          bindMobile(memberInfo?.type === 'member' ? verifyCodeBind : verifyCodeRegister)
        }
      }
    })
  }

  const initData = () => {
    let typesArr: any[]
    if (bindType === 'all') {
      typesArr = window.bo !== 'cn' ? [
        { value: 'mobile', label: i18n.t('mkt.common.mobile') },
        { value: 'email', label: i18n.t('mkt.common.email') }
      ] : [
        { value: 'mobile', label: i18n.t('mkt.common.mobile') }
      ]
    } else if (bindType === 'mobile') {
      typesArr = [{ value: 'mobile', label: i18n.t('mkt.common.mobile') }]
    } else if (bindType === 'email') {
      typesArr = [{ value: 'email', label: i18n.t('mkt.common.email') }]
    }
    setTypes(typesArr)
    setType(typesArr[0].value)
    setUserNameInfo({})
  }
  useIonViewWillEnter(() => {
    initData()
  })
  const handleCheck = () => {
    setChecked(!checked)
  }
  const agreementJudge = boJudge.checkKey('agreement') // bo控制隐私协议模块
  const hasAgree = !!memberInfo?.agreeTime
  return (
    <IonPage className='ibind-page'>
      <UseHeader title={i18n.t('pageName.binding')} onBack={() => history.goBack()} />
      <IonContent className='page-content'>
        <div className='panel'>
          {
            bindType === 'all' &&
              <div className='switch'>
                <UseSwitchTab
                  types={types}
                  value={type}
                  onChange={(value: any) => {
                    if (value === type) return
                    setType(value)
                  }}
                />
              </div>
          }
          <UserNameInput type={type} onChange={(val: any) => setUserNameInfo(val)} />
          {agreementJudge && !hasAgree && <AgreementCheck checked={checked} onCheck={handleCheck} />}
          <div className='footer'>
            <MktButton text={i18n.t('mkt.common.gitVerCode')} disabled={!userNameInfo.valid} onClick={handleNext} />
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(Binding)
